// CSP Detection and Cookie Management

// Global variable to track if alternate URI should be used
if (typeof window !== "undefined") {
window.hotglue_widget_useAlternateUri = false;
}

// Simple cookie utility
const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

// Test call to trigger security policy violation check early
const testApiAccess = async (api_url, legacy_api_url) => {
  // If no legacy API URL is available, skip CSP detection
  if (!legacy_api_url) {
    return Promise.resolve();
  }

  // Check cookie first - if we already know we need alternate URI, skip the test
  const cookieValue = getCookie('useAlternateUri');
  if (cookieValue === 'true') {
    console.log('Using alternate URI based on cookie');
    window.hotglue_widget_useAlternateUri = true;
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    // Set up a one-time listener for CSP violations
    const cspListener = (e) => {
      if (e.blockedURI && e.blockedURI.includes(api_url)) {
        console.log(`CSP violation detected for API URL ${api_url}, using alternate URI ${legacy_api_url}`);
        window.hotglue_widget_useAlternateUri = true;
        setCookie('useAlternateUri', 'true', 7); // Remember for 7 days
      }
    };
    
    // Add the listener
    document.addEventListener('securitypolicyviolation', cspListener);
    
    // Make the test request
    fetch(`${api_url}/ping`, { 
      method: 'HEAD',
      mode: 'no-cors'
    })
    .catch(() => {
      // Expected to fail if blocked by CSP
      console.log('API access test completed');
    })
    .finally(() => {
      // Wait a bit for CSP events to fire, then clean up
      setTimeout(() => {
        document.removeEventListener('securitypolicyviolation', cspListener);
        resolve();
      }, 100); // Reduced delay since we're handling the event directly
    });
  });
};

export { testApiAccess, setCookie, getCookie };
